export default __webpack_public_path__ + "static/media/IconDesc_ThermalPropulsionRocket.64.079cd353.png";